/* eslint-disable ember/no-empty-glimmer-component-classes */
import Component from '@glimmer/component';
import styles from './styles.css';

// interface HomeOrganisationsArgs {}

export default class HomeOrganisations extends Component /*<HomeOrganisationsArgs>*/ {
  styles = styles;
}
